<div class="input-container" [ngStyle]="{ 'width': customWidth }">
	<div class="icon" [ngClass]="{ 'disabled': disabled }">
		<i class="ph ph-magnifying-glass"></i>
	</div>
	<input class="input-field" type="text" [placeholder]="placeholder" [(ngModel)]="searchTerm"
		(ngModelChange)="onSearchTermChange($event)" [ngClass]="{ 'disabled': disabled }">
</div>